module.exports = __webpack_public_path__ + "img/banner4.acb8ff1e.jpg";